import api from '../lib/api'
import router from '../router/index'
import i18n from "../lang/i18n";

export default {
    actions: {
        sendRequest({commit}, payload) {
            // commit('clearSnackBar');

            if (!!this.payload) {
                for (let key in this.payload.data) {
                    if (this.payload.data[key] === undefined) {
                        this.payload.data[key] = null;
                    }
                }
            }

            const requestOptions = {
                method: payload.method,
                url: payload.path,
                data: payload.data,
            };

            if (payload.headers) requestOptions.headers = payload.headers;

            if (payload.params) requestOptions.params = payload.params;

            return api.request(requestOptions)
                .then((res) => {

                    let data = res.data;

                    return data
                })
                .catch(err => {

                    if (err.response && err.response.data && err.response.status === 400) {

                        if (err.response.data.error === "token is empty") {
                            commit('setLogin', 'false');
                            router.push('/login');
                            throw err;
                        }

                        if (err.response.data.valid_errors && payload.formErrors !== undefined && payload.formErrors.add !== undefined) {

                            payload.formErrors.clear();

                            err.response.data.valid_errors.forEach(item => {

                                let msg = item.message;

                                if (item.tag === 'error_code') {
                                    msg = i18n.messages[i18n.locale]['apiError'][msg];
                                }

                                payload.formErrors.add({
                                    field: item.field,
                                    msg,
                                });
                            });
                        }

                        if (err.response.data.error) {

                            let msg = err.response.data.error;
                            if (i18n.messages[i18n.locale]['msg'][err.response.data.error] !== undefined) {
                                msg = i18n.messages[i18n.locale]['msg'][err.response.data.error];
                            }

                            commit('setSnackBarError', msg)
                        }

                    } else if (err.response && err.response.data && err.response.status === 403) {

                        if (err.response.data.error === "forbidden") {
                            commit('setLogin', 'false');
                            router.push({name: 'login'});
                            throw err;
                        } else if (err.response.data.reason === 'not_paid') {
                            router.push({name: 'profile'});
                            this.dispatch('loadUserProfile');
                        }

                    } else {
                        commit('setSnackBarError', err.message)
                    }

                    throw err
                })
        }
    }
}